export enum ActivityType {
    FREE = 1,
    PROGRAMMED = 2,
    AUTOMATIC = 3
}